import { Component } from '@angular/core';
import { FileManagerComponent } from '../../../components/pages/file-manager/file-manager.component';

@Component({
  selector: 'app-compliance-file-manager',
  imports: [FileManagerComponent],
  templateUrl: './compliance-file-manager.component.html',
  styleUrl: './compliance-file-manager.component.scss'
})
export class ComplianceFileManagerComponent {
  initialPath: string = 'compliance';
}
